export default {
  loading: 'Загрузка...',
};
